import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AppProvider } from './context/AppContext';
import PrivateRoute from './components/PrivateRoute.js';

import Landing from './pages/Landing';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Invoice from './pages/Invoice';
import CV from './pages/CV';
import Settings from './pages/Settings';
import AdminPage from './pages/AdminPage';
import Documentation from './pages/Documentation';


import './app.css';

function App() {
  return (
    <AppProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={
              <PrivateRoute><Dashboard /></PrivateRoute>
            } />
            <Route path="/invoice" element={
              <PrivateRoute><Invoice /></PrivateRoute>
            } />
            <Route path="/cv" element={
              <PrivateRoute><CV /></PrivateRoute>
            } />
            <Route path="/parametres" element={
              <PrivateRoute><Settings /></PrivateRoute>
            } />
            <Route path="/documentation" element={<Documentation />} />
            <Route path="/admin/users" element={
              <PrivateRoute adminOnly><AdminPage tab="users" /></PrivateRoute>
            } />
            <Route path="/admin/documents" element={
              <PrivateRoute adminOnly><AdminPage tab="documents" /></PrivateRoute>
            } />
            <Route path="/admin/stats" element={
              <PrivateRoute adminOnly><AdminPage tab="stats" /></PrivateRoute>
            } />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Router>
      </AuthProvider>
    </AppProvider>
  );
}

export default App;